import { render, staticRenderFns } from "./ApplyDomainQuota.vue?vue&type=template&id=0cb7f342&"
import script from "./ApplyDomainQuota.vue?vue&type=script&lang=js&"
export * from "./ApplyDomainQuota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports